<template>
    <v-card :loading="imageLoading" style="padding:10px;">
        <v-card-title style="padding-top:12px; padding-bottom:6px;">{{ title }}</v-card-title>
        <v-card-subtitle v-if="!isProfilePicture" style="margin-top:1px;">*This could be a profile picture or proof of
            identity</v-card-subtitle>
        <v-card-text v-if="!spinner">
            <v-img v-if="previewImage != undefined" :src="previewImage">
            </v-img>
            <v-file-input v-model="currentImage" @change="chosenFile" :loading="loading" color="var(--houseColor)" counter
                show-size ref="file" prepend-icon="mdi-camera"></v-file-input>
        </v-card-text>
        <v-col v-if="spinner == true" align="center">
            <v-progress-circular :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'" size="72"
                indeterminate></v-progress-circular>
        </v-col>
        <v-card-actions v-if="!spinner">

            <v-spacer></v-spacer>
            <!-- <input class="float-left" @change="chosenFile" type="file" ref="file"> -->
            <v-btn class="float-right" :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                v-on:click="uploadImage">Upload</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import RestResource from '../RestResource.js';
import { mapActions } from 'vuex';
const restResourceService = new RestResource();

export default {
    name: "UploadImage",
    setup() {

    },
    props: {
        title: String,
        albumName: String,
        //Something to distingish between whats being uploaded
        //This could change the get predefined call to get different scope in S3
        isProfilePicture: Boolean,
        isProof: Boolean,
        proofName: String
    },
    components: {

    },
    data: () => ({
        imageLoading: false,
        openFileExplorer: false,
        currentImage: undefined,
        previewImage: undefined,
        progress: 0,
        message: "",
        imageInfos: [],
        imageExtentionsAllowed: ['image/png', 'image/jpeg'],
        loading: false,
        spinner: false,
    }),
    mounted: function () {

    },
    methods: {
        ...mapActions([
            'fetchAccountDetails',
        ]),
        chosenFile: function () {
            this.loading = "var(--houseColor)";
            if (this.currentImage == null) {
                this.loading = false;
                return this.previewImage = null;
            }
            //Check if image extention allowed
            if ((!this.imageExtentionsAllowed.includes(this.currentImage['type'])))
                return this.$emit('snack', 'Invalid image type (png or jpeg)...');

            //Creates image to preview
            this.previewImage = URL.createObjectURL(this.currentImage);
            this.progress = 0;
            this.message = "";
            this.loading = false;
        },
        async uploadImage() {
            this.spinner = true;
            //Check the file is a valid image format
            if (this.currentImage == undefined) {
                this.spinner = false;
                return this.$emit('snack', 'Please choose a image file...');
            }

            //Check if image extention allowed
            if ((!this.imageExtentionsAllowed.includes(this.currentImage['type']))) {
                this.spinner = false;
                return this.$emit('snack', 'Invalid image type (png or jpeg)...');
            }
            //call upload service passing currentImage
            if (this.$props.isProof) {
                const response = await restResourceService.uploadProofImageToS3(this.currentImage, this.$props.proofName);
                this.spinner = false;
                if(response.status == 200){
                    this.$emit('reloadImages');
                    this.$emit('snack', "Image successfully uploaded");
                    //Call something to set the link on the proof
                }
            } else {
                const response = await restResourceService.uploadImageToS3(this.currentImage);
                this.spinner = false;
                if (response.status == 200) {
                    this.$emit('reloadImages');
                    this.$emit('snack', "Image successfully uploaded")
                    //Checks if needs to make image profile picture
                    if (this.$props.isProfilePicture) {
                        const res = await restResourceService.setProfilePicture(this.currentImage.name);
                        if (res == 200)
                            this.$emit('snack', "Profile picture set");

                        this.fetchAccountDetails();
                        this.$emit('reloadImages');
                        this.$router.push({ path: "/changeProfilePicture" });
                    }
                    this.currentImage = undefined;
                    this.previewImage = undefined;
                }
            }
        },
    },
}
</script>

<style scoped></style>